// extracted by mini-css-extract-plugin
export default {"container":"bE-z","innerContainer":"cE-z","multipleLines":"dE-z","heading":"eE-z","content":"fE-z","linkColor":"gE-z"};